import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import Edit from './Edit';
import createSagaMiddleware from 'redux-saga';
import createRavenMiddleware from 'raven/middleware';
import { appendLoggerMiddlewareInDev } from 'utils/redux';
import rootReducer from './reducers';
import rootSaga from './sagas';
import { getBlocks } from './reducers/edito';
import { getImage } from './reducers/images';
import { getTargets } from './reducers/diffusion';
import $ from 'jquery';
import { post } from 'utils/fetch';
import { purify } from 'utils/json';
import { error, storeSuccess } from 'plugins/toastr';
import { hideFormLoader } from 'plugins/loader';
import publish from './publish';

export const renderEdit = id => {
  const sagaMiddleware = createSagaMiddleware();
  const ravenMiddleware = createRavenMiddleware();

  const middleware = [sagaMiddleware, ravenMiddleware];

  appendLoggerMiddlewareInDev(middleware);

  const store = createStore(rootReducer, applyMiddleware(...middleware));
  sagaMiddleware.run(rootSaga);

  // Rendering React UI
  ReactDOM.render(
    <Provider store={store}>
      <Edit />
    </Provider>,
    document.getElementById('root')
  );

  const $form = $('form');
  $form.on('submit', evt => {
    evt.preventDefault();

    const $form = $(evt.currentTarget);

    // Serializing form data
    const data = new FormData($form[0]);

    // Appending redux state
    const state = store.getState();

    const image = getImage(state);
    if (image) {
      data.append('image', JSON.stringify(image));
    }

    const blocks = getBlocks(state);
    data.append('blocks', JSON.stringify(blocks, purify));

    const targets = getTargets(state).map(e => ({
      role: e.role,
      tags: e.tags,
    }));
    data.append('targets', JSON.stringify(targets));

    return handleFormSubmit($form, data, res => {
      // Storing flash in session for toast
      storeSuccess('Evènement mis à jour avec succès');

      // Moving to list page
      window.location.replace(res.headers.get('X-Redirect-Url'));
    });
  });
};

function handleFormSubmit($form, data, successCallback) {
  const handleFormErrors = errors => {
    // Clearing existing errors
    $form.find('.field').removeClass('error');

    const formError = errors[0];
    if (formError && formError.key) {
      $form
        .find(`input[name="${formError.key}"]`)
        .closest('.field')
        .addClass('error');
    }
  };

  const $submitButton = $(document.activeElement);
  const postForm = ({ push, postpone }) => {
    const url = $submitButton.attr('formaction') || $form.attr('action');

    // Append push to data
    data.append('push', push);

    return post(url, data).then(
      res => {
        hideFormLoader($form);
        successCallback(res);
      },
      err => {
        hideFormLoader($form);

        console.log('Error attempting to save calendar event', err);
        if (err.res.status === 400) {
          err.res.json().then(json => handleFormErrors(json));
        } else {
          error(`Une erreur est survenue pendant la sauvegarde de l'évènement`);
        }
      }
    );
  };

  // Displaying push settings modal if needed
  if ($submitButton.hasClass('publish')) {
    publish(push => postForm({ push }));
  } else {
    postForm({});
  }

  return false;
}



// WEBPACK FOOTER //
// ./src/modules/calendar/form.js